import { Typography } from "@mui/material";

const TypographyLabel = (props: any) => {
  return <Typography {...props}>{props.title}</Typography>;
};

export default TypographyLabel;
